
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectAnlageTypesEnum } from '../models/work-project-anlage-types-enum';
import { WorkProjectSystemTypesEnum } from '../models/work-project-system-types-enum';
import { WorkProjectAnlageSupplyTypesEnum } from '../models/work-project-anlage-supply-types-enum';

export function getUpdateProjectAnlageUndObjektdatenDtoFormGroup() {
return new FormGroup({
    powerKwp: new FormControl<number | undefined>(undefined),
    revenueKwhSpecific: new FormControl<number | undefined>(undefined),
    constructionType: new FormControl<WorkProjectAnlageTypesEnum | undefined>(undefined),
    systemType: new FormControl<WorkProjectSystemTypesEnum | undefined>(undefined),
    supply: new FormControl<WorkProjectAnlageSupplyTypesEnum | undefined>(undefined),
    esti: new FormControl<boolean | undefined>(undefined),
    realestatetypeId: new FormControl<number | undefined>(undefined),
    lot: new FormControl<string | undefined>(undefined, [Validators.maxLength(10)]),
    buildingpermit: new FormControl<boolean | undefined>(undefined),
    supplierId: new FormControl<number | undefined>(undefined),
    authenticatorId: new FormControl<number | undefined>(undefined),
    powerHakAmpere: new FormControl<number | undefined>(undefined),
})
;
}
      